"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _radium = _interopRequireDefault(require("radium"));

var rotateKeyframes = _radium.default.keyframes({
  '0%': {
    transform: 'translate(-50%, -50%) rotate(0deg)'
  },
  '50%': {
    transform: 'translate(-50%, -50%) rotate(180deg)'
  },
  '100%': {
    transform: 'translate(-50%, -50%) rotate(360deg)'
  }
}, 'rotate');

var scaleKeyframes = _radium.default.keyframes({
  '0%': {
    opacity: 1,
    transform: 'translate(-50%, -50%) scale(1)'
  },
  '100%': {
    opacity: 1,
    transform: 'translate(-50%, -50%) scale(1)'
  },
  '30%': {
    opacity: 0.3,
    transform: 'translate(-50%, -50%) scale(.15)'
  }
}, 'scale');

var styles = {
  wrapper: {
    display: 'block',
    fontSize: 0,
    color: '#fff',
    width: '96px',
    height: '96px'
  },
  outer: {
    margin: 'auto',
    boxSizing: 'border-box',
    display: 'inline-block',
    float: 'none',
    borderColor: 'currentColor',
    top: '50%',
    left: '50%',
    borderRadius: '100%',
    position: 'absolute',
    background: 'transparent',
    borderStyle: 'solid',
    borderRightColor: 'transparent',
    borderLeftColor: 'transparent',
    animation: 'x 1s cubic-bezier(.09, .57, .49, .9) infinite',
    animationName: rotateKeyframes,
    width: '96px',
    height: '96px',
    borderWidth: '6px'
  },
  inner: {
    margin: 'auto',
    boxSizing: 'border-box',
    display: 'inline-block',
    float: 'none',
    backgroundColor: 'currentColor',
    border: '0 solid currentColor',
    position: 'absolute',
    top: '50%',
    left: '50%',
    borderRadius: '100%',
    animation: 'x 1s cubic-bezier(.09, .57, .49, .9) infinite',
    animationName: scaleKeyframes,
    width: '48px',
    height: '48px'
  }
};

var Spinner = function Spinner() {
  return /*#__PURE__*/_react.default.createElement("div", {
    style: styles.wrapper
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: styles.outer
  }), /*#__PURE__*/_react.default.createElement("div", {
    style: styles.inner
  }));
};

var _default = (0, _radium.default)(Spinner);

exports.default = _default;